import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { About } from './About';
import * as $ from 'jquery';
import {Globals} from '../globals';
@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.scss']
})
export class AboutusComponent implements OnInit {
about: About;
// headerPic;
  constructor(private http: HttpClient , private route: ActivatedRoute , public globals: Globals) { }

  ngOnInit() {
    $(window).scrollTop(0);
 
    this.http.get<About>(this.globals.urlMain +'about_us').subscribe(data => {
    this.about = data;
    // this.headerPic = data.data.header_img;


  });
  // localStorage.setItem('headerImage', this.headerPic ) ;
  }


}
